// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"279":"6789d8b6cc95b6c8","567":"fbc96fd0272a1af4","771":"df0f9df40cf2ab20","793":"d82aa3fd99b342e9","861":"16541b8f5ec50d4a"}[chunkId] + ".js";
};